import type { LC, LiveElement } from '@use-gpu/live';
import type { ShaderSource } from '@use-gpu/shader';

import { yeet, provide, useMemo } from '@use-gpu/live';

import { getRenderFunc } from '../hooks/useRenderProp';
import { useShader } from '../hooks/useShader';
import { useShaderRef } from '../hooks/useShaderRef';

import { QueueReconciler } from '../reconcilers/index';

import { MaterialContext, useMaterialContext } from '../providers/material-provider';

import { getFresnelEffectSurface } from '@use-gpu/wgsl/instance/effect/fresnel-effect.wgsl';

const {signal} = QueueReconciler;

export type FresnelMaterialEffectProps = {
  opacity?: number,

  render?: (material: Record<string, Record<string, ShaderSource | null | undefined | void>>) => LiveElement,
  children?: LiveElement | ((material: Record<string, Record<string, ShaderSource | null | undefined | void>>) => LiveElement),
};

export const FresnelMaterialEffect: LC<FresnelMaterialEffectProps> = (props: FresnelMaterialEffectProps) => {
  const {
    opacity = 0,
    children,
  } = props;

  const material = useMaterialContext();

  const {
    shaded: {
      getSurface,
    }
  } = material;

  const o = useShaderRef(opacity);
  const boundSurface = useShader(getFresnelEffectSurface, [getSurface, o]);

  const context = useMemo(() => ({
    ...material,
    shaded: {
      ...material.shaded,
      getSurface: boundSurface,
    },
  }), [boundSurface, material]);

  const render = getRenderFunc(props);
  const view = render ? render(context) : children;
  return render ?? children ? provide(MaterialContext, context, [signal(), view]) : yeet(context);
}
